import * as React from 'react';
import { MastheadPortalId } from '../../../models/AdminModels';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { SuccessInbox } from '../../containers/successInbox/SuccessInbox';

export const AdminSuccessInboxPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='Success Inbox' />
			</Portal>
			<SuccessInbox />
		</AdminDashboardPageLayout>
	);
};
